import React, { useState } from 'react'
import { Page } from './PageMargins'
import { Typography } from '@mui/material'
import { MovingButtonModal } from '../Modals/MovingModal'

export const TestRoute: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(true)
  return (
    <Page>
      <Typography variant="body1">
        Look at you, you've found a secret!
      </Typography>
      <MovingButtonModal
        open={isModalOpen}
        onClose={() => {
          alert('You must submit the modal to close')
          return
        }}
        onAccept={() => {
          setIsModalOpen(false)
          return
        }}
      />
    </Page>
  )
}

export default TestRoute
